import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {InformationStatus} from '@ideals/types';
import {SnackBarComponent} from './snack-bar.component';

const DEFAULT_SNACK_BAR_CONFIG: MatSnackBarConfig = {
  duration: 2000,
  horizontalPosition: 'end',
  verticalPosition: 'bottom',
};

@Injectable()
export class SnackBarService {
  constructor(private readonly _matSnackBar: MatSnackBar) {
  }

  private static _getCombinedPanelClass(status: string, additionalClass: string | Array<string>): Array<string> {
    if (additionalClass) {
      return Array.isArray(additionalClass) ? [...additionalClass, status] : [additionalClass, status];
    }

    return [status];
  }

  public openSuccess(config: MatSnackBarConfig = {}): void {
    const status = InformationStatus.Success;

    this._openFromComponent({
      ...DEFAULT_SNACK_BAR_CONFIG,
      ...config,
      panelClass: SnackBarService._getCombinedPanelClass(status, config.panelClass),
      data: {status},
    });
  }

  public openWarning(config: MatSnackBarConfig = {}): void {
    const status = InformationStatus.Warning;

    this._openFromComponent({
      ...DEFAULT_SNACK_BAR_CONFIG,
      ...config,
      panelClass: SnackBarService._getCombinedPanelClass(status, config.panelClass),
      data: {status},
    });
  }

  public openError(config: MatSnackBarConfig = {}): void {
    const status = InformationStatus.Danger;

      this._openFromComponent({
        ...DEFAULT_SNACK_BAR_CONFIG,
        ...config,
        panelClass: SnackBarService._getCombinedPanelClass(status, config.panelClass),
        data: {status},
      });
  }

  private _openFromComponent(config: MatSnackBarConfig): void {
    this._matSnackBar.openFromComponent(SnackBarComponent, config);
  }
}
